import { createRouter, createWebHistory } from "vue-router";

const routes = [
  // tnb
  {
    path: "/auth",
    name: "auth",
    component: () => import("../components/tnb/AuthView.vue"),
  },
  {
    path: "/auth/login",
    name: "login",
    component: () => import("../components/tnb/LoginView.vue"),
  },
  {
    path: "/auth/join",
    name: "join",
    component: () => import("../components/tnb/JoinView.vue"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("../components/tnb/SearchView.vue"),
  },

  // home
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },

  //ABOUT US
  {
    path: "/aboutus/about",
    name: "about",
    component: () => import("../views/about/AboutView.vue"),
  },

  {
    path: "/aboutus/greetings",
    name: "greetings",
    component: () => import("../views/about/GreetingsView.vue"),
  },

  //프로그램(팀소개)
  {
    path: "/program/VFX",
    name: "vfx",
    component: () => import("../views/program/VFX.vue"),
  },
  {
    path: "/program/specialFilming",
    name: "specialFilming",
    component: () => import("../views/program/SpecialFilming.vue"),
  },
  {
    path: "/program/specialSound",
    name: "specialSound",
    component: () => import("../views/program/SpecialSound.vue"),
  },
  {
    path: "/program/specialLighting",
    name: "specialLighting",
    component: () => import("../views/program/SpecialLighting.vue"),
  },
  {
    path: "/program/specialEffects",
    name: "specialEffects",
    component: () => import("../views/program/SpecialEffects.vue"),
  },
  {
    path: "/program/martialArtsAction",
    name: "martialArtsAction",
    component: () => import("../views/program/MartialArtsAction.vue"),
  },

  //BRAND_이치윤
  {
    path: "/brand/brandlcy",
    name: "brandlcy",
    component: () => import("../views/brand/BrandLCY.vue"),
  },

  //우리 팀 HISTORY
  //NEWS CENTER
  //STUDY CENTER
  //NEWS CENTER
  //STUDY CENTER

  //커뮤니티
  //공지사항
  {
    path: "/notice",
    name: "notice",
    component: () => import("../views/community/NoticeView.vue"),
  },

  //게시판 상세페이지
  {
    path: "/notice/:id",
    name: "noticeBoardDetail",
    component: () => import("../components/NoticeBoardDetail.vue"),
    props: true,
  },

  //보도자료
  {
    path: "/pressRelease",
    name: "pressRelease",
    component: () => import("../views/community/PressRelease.vue"),
  },

  //뉴스레터
  {
    path: "/news",
    name: "news",
    component: () => import("../views/community/NewsView.vue"),
  },

  //티켓FAQ
  {
    path: "/ticket",
    name: "ticket",
    component: () => import("../views/community/TicketView.vue"),
  },

  //퍼포먼스 프로그램
  {
    path: "/performanceProgram",
    name: "performanceProgram",
    component: () => import("../views/performance/PerformanceProgram.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 이전에 저장된 위치로 스크롤 (브라우저 뒤로가기)
    } else {
      return { top: 0 }; // 페이지 전환 시 스크롤 맨 위로
    }
  },
});

export default router;
